import { useState, useEffect } from 'react';

const LIB_NAME = 'Gtag';
const GA4_ID = 'G-V9CL3EXPP5';
const AW_ID = 'AW-681616889';
const GTAG_URI = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;

/**
 * @summary A variant of useScript hook, loads gtag async-ly
 * @see https://stackoverflow.com/a/65189254
 * @returns useGtag
 */
const useGtag = () => {
  // if (process.env.REACT_APP_NODE_ENV === 'production') {
  const [lib, setLib] = useState({});
  const createScriptEl = () => document.createElement('script');
  const parseLocalStorage = data => JSON.parse(localStorage.getItem(data));

  let gtagUserId;

  useEffect(() => {
    const script = createScriptEl();
    const config = createScriptEl();
    const masterAccount = parseLocalStorage('masterAccount');
    const member = parseLocalStorage('member');
    if (masterAccount) {
      gtagUserId = `gtag('set', {'user_id': '${masterAccount.id}'});`;
    } else if (member) {
      gtagUserId = `gtag('set', {'user_id': '${member._id}'});`;
    }

    script.src = GTAG_URI;
    script.async = true;
    script.onload = () => setLib(() => window[LIB_NAME]);

    const inlineScript = document.createTextNode(`
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${GA4_ID}');
      gtag('config', '${AW_ID}');
      ${gtagUserId}
    `);

    config.appendChild(inlineScript);

    document.body.appendChild(script);
    document.body.appendChild(config);

    return () => {
      document.body.removeChild(script);
      document.body.removeChild(config);
    };
  }, []);
  return lib;
  // }
};

export default useGtag;
